import { PropsWithChildren } from 'react'
import { Base } from '@itsrever/design-system'

export const IntegrationTag = ({ children }: PropsWithChildren) => (
  <Base.Badge variant="outline">{children}</Base.Badge>
)
